import { ColorType } from './getColorFromRange.types';

const PERCENTAGE_RANGES: PercentageRange[] = [
  [1, 20],
  [21, 38],
  [39, 54],
  [55, 68],
  [69, 80],
  [81, 91],
  [92, 100],
];

const EER_COLORS: Colors = [
  '#e61434',
  '#ed7521',
  '#f69c58',
  '#ffcf02',
  '#81c53d',
  '#18ab4e',
  '#02754b',
];
const EIR_COLORS: Colors = [
  '#5d5d5d',
  '#7b7b7b',
  '#9e9e9e',
  '#477bbd',
  '#6898d0',
  '#8bb8ed',
  '#bfd7eb',
];

const COLORS_FACTORY: Record<ColorType, Colors> = {
  [ColorType.EER]: EER_COLORS,
  [ColorType.EIR]: EIR_COLORS,
};

type PercentageRange = number[];

type Colors = string[];

type GetColorFromRange = (value: number, colorType: ColorType) => string;

type IsRangeArgs = {
  low: number;
  high: number;
  value: number;
};

type IsRange = (args: IsRangeArgs) => boolean;

type GenerateRangeMap = (colorType: ColorType) => Map<PercentageRange, string>;

const generateRangeMap: GenerateRangeMap = (typeColor) => {
  const map = PERCENTAGE_RANGES.reduce<[number[], string][]>(
    (acc, range, index) => {
      const colors = COLORS_FACTORY[typeColor];
      const color = colors[index];

      return [...acc, [range, color]];
    },
    []
  );

  return new Map(map);
};

const isRange: IsRange = ({ low, high, value }) =>
  value >= low && value <= high;

export const getColorFromRange: GetColorFromRange = (value, colorType) => {
  const range = PERCENTAGE_RANGES.find((range) => {
    const [low, high] = range;

    return isRange({ low, high, value });
  });

  return generateRangeMap(colorType).get(
    range ?? PERCENTAGE_RANGES[0]
  ) as string;
};
